import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Button from "elevate-ui/Button";

import NoBlogPosts from "./NoBlogPosts";

type Props = {
  classes: Object,
};

const BlogNotFound = ({ classes }: Props) => {
  return (
    <div className={classes.root}>
      <NoBlogPosts />
      <Typography
        className={classNames(classes.notFound, classes.heading)}
        type="heading2"
      >
        No Blog Posts
      </Typography>
      <Typography
        className={classNames(classes.notFound, classes.body)}
        type="body"
      >
        There are no blog posts at the moment, please check back later.
      </Typography>
      <Button innerClassName={classes.homeButton} href="/" element="a">
        Go home
      </Button>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "64px 0px 96px",
  },
  notFound: {
    margin: "0px auto",
    width: "100%",
    maxWidth: "375px",
    textAlign: "center",
  },
  illustration: {
    width: "100%",
    height: "100%",
  },
  heading: {
    marginTop: theme.spacing.unit,
    fontSize: "26px",

    [theme.breakpoints(600)]: {
      marginTop: theme.spacing.unit * 2,
      fontSize: "32px",
    },
  },
  body: {
    padding: "0px 24px 16px",

    [theme.breakpoints(600)]: {
      padding: "8px 24px 20px",
    },
  },
  homeButton: {
    width: "200px",
    fontSize: "16px",
    padding: "12px 16px",
  },
}))(BlogNotFound);
